import { Switch } from "../components/bits";
import { useCallback, useEffect, useState } from "react";
import { api, act, flash, post } from "../lib/api";
import { useLive } from "../lib/time";
import { Sheet } from "../components/bits";
import { ResetPasswordSheet, RemoveSheet } from "../components/PasswordSheet";

const TEAMS = [["design", "Design"], ["video", "Video"], ["servicing", "Client servicing"], ["social", "Social media"], ["events", "Events"],
  ["accounts", "Accounts"], ["management", "Management"], ["ai", "AI & strategy"]];
const WHO = [["maker", "Maker", true, false, false, false], ["lead", "Lead", true, "Own team", false, false], ["planner", "Planner", false, true, true, true],
  ["accounts", "Accounts", false, false, true, true], ["management", "Management", false, true, true, true]];

function status(u) {
  if (u.leftAt) return ["Left CK", "left"];
  if (!u.active) return ["Switched off", "off"];
  return u.bench ? ["On the daily list", "on"] : ["Active", "act"];
}

function AddPerson({ onClose, onDone }) {
  const [f, setF] = useState({ name: "", email: "", team: "design", designation: "", reportsTo: null, bench: true });
  const [err, setErr] = useState(null);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value });
  async function save() {
    const r = await post("/people", f);
    if (!r.ok) return setErr(r.error.message);
    await act(Promise.resolve(r));
    onDone();
  }
  return (
    <Sheet title="Add person" onClose={onClose} testid="add-person-sheet">
      <label className="fld-lbl">Full name</label><input className="fld" value={f.name} onChange={set("name")} data-testid="person-name" />
      <label className="fld-lbl">Work email</label><input className="fld" value={f.email} onChange={set("email")} data-testid="person-email" />
      <div className="two">
        <div><label className="fld-lbl">Team</label><select className="fld" value={f.team} onChange={set("team")} data-testid="person-team">
          {TEAMS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}</select></div>
        <div><label className="fld-lbl">Designation</label><input className="fld" value={f.designation} onChange={set("designation")} data-testid="person-designation" /></div>
      </div>
      <label className="check"><input type="checkbox" checked={f.bench} onChange={set("bench")} data-testid="person-bench" /> On the daily list</label>
      {err && <p className="err" data-testid="add-person-error">{err}</p>}
      <button className="btn-primary" onClick={save} data-testid="add-person-save">Add person</button>
    </Sheet>
  );
}

function DailySwitch({ me, u, run }) {
  if (!["design", "video"].includes(u.team) || u.leftAt) return null;
  return <Switch checked={!!u.bench} disabled={!me.caps.people || !u.active} label={`${u.short} on the daily list`}
    onChange={(v) => run(post(`/people/${u.id}/daily-list`, { on: v }), u.id)} testid={`daily-list-${u.id}`} />;
}

function Actions({ me, u, run, setSheet }) {
  const c = me.caps, self = u.id === me.user.id;
  if (u.leftAt) return c.offboard ? <button className="btn-ghost sm" onClick={() => run(post(`/people/${u.id}/restore`, { rev: u.rev }))} data-testid={`restore-${u.id}`}>Restore</button> : null;
  return (
    <div className="pacts">
      <Switch checked={!!u.active} disabled={!c.people || self} label={`${u.short}'s ID ${u.active ? "is on" : "is off"}`}
        onChange={(v) => run(post(`/people/${u.id}/${v ? "switch-on" : "switch-off"}`), u.id)} testid={`switch-${u.active ? "off" : "on"}-${u.id}`} />
      {c.passwords && !self && <button className="ibtn hit" aria-label={`Reset ${u.short}'s password`} title="Reset password" onClick={() => setSheet({ kind: "reset", u })} data-testid={`reset-pw-${u.id}`}>⚿</button>}
      {c.offboard && !self && <button className="ibtn hit danger-t" aria-label={`Remove ${u.short} from the team`} title="Remove from the team" onClick={() => setSheet({ kind: "remove", u })} data-testid={`remove-${u.id}`}>⊖</button>}
    </div>
  );
}

export default function Team({ me }) {
  const [people, setPeople] = useState(null);
  const [adding, setAdding] = useState(false);
  const [showLeft, setShowLeft] = useState(false);
  const [sheet, setSheet] = useState(null);
  const [search, setSearch] = useState("");
  const [teamF, setTeamF] = useState("all");
  const load = useCallback(async () => { const r = await api("/people"); if (r.ok) setPeople(r.data.items); }, []);
  useEffect(() => { load(); }, [load]);
  useLive(load, (t) => /^(person|leave|day)\./.test(t));
  const run = async (p, uid) => {
    const r = await p;
    const tok = r.ok && r.data?.undoToken;
    flash(r.ok ? r.data?.message : r.error.message, tok ? async () => { const x = await post(`/people/${uid}/undo`, { undoToken: tok }); if (!x.ok) flash(x.error.message); load(); } : undefined);
    load();
    return r;
  };
  if (!people) return <div className="loading" data-testid="team-loading">Loading the team…</div>;
  const current = people.filter((u) => !u.leftAt);
  const q = search.trim().toLowerCase();
  const shown = people.filter((u) => (showLeft || !u.leftAt) && (teamF === "all" || u.team === teamF)
    && (!q || [u.name, u.email, u.designation, u.id].some((x) => (x || "").toLowerCase().includes(q))));
  const short = Object.fromEntries(people.map((u) => [u.id, u.short]));
  const teams = new Set(current.map((u) => u.team)).size;
  return (
    <div data-testid="team-page">
      <div className="thead2">
        <div><h1 className="stackh"><span className="hl-ink">THE</span> <span className="hl-mari">KHICHDI</span> <span className="hl-g">CREW</span></h1>
          <p className="tsub">{current.length} ids. one kitchen.</p></div>
        <div className="fstats" data-testid="team-stats">
          <div className="st"><b>{current.filter((u) => u.active).length}</b><span className="lbl">active</span></div>
          <div className="st"><b>{current.filter((u) => !u.active).length}</b><span className="lbl">off</span></div>
          <div className="st"><b>{current.filter((u) => u.active && u.bench).length}</b><span className="lbl">on the daily list</span></div>
          <div className="st"><b>{teams}</b><span className="lbl">teams</span></div>
        </div>
      </div>
      <div className="tgrid">
        <div>
          <div className="tbar">
            <input className="fld tsearch" placeholder="Name, email, designation or ID" aria-label="Search people" value={search} onChange={(e) => setSearch(e.target.value)} data-testid="team-search" />
            <label className="spot"><span className="lbl">Team</span><select className="fld" value={teamF} onChange={(e) => setTeamF(e.target.value)} data-testid="team-filter">
              <option value="all">All teams</option>{TEAMS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}</select></label>
            <span className="num hint0">{shown.length} IDs</span>
            <label className="check sm"><input type="checkbox" checked={showLeft} onChange={(e) => setShowLeft(e.target.checked)} data-testid="show-left" /> Show people who left</label>
            {me.caps.people && <button className="btn-solid ml-auto" onClick={() => setAdding(true)} data-testid="add-person-button">+ Add person</button>}
          </div>
          <p className="hint0">Designers and editors on the daily list get My day and a row on the Floor.</p>
          <div className="xt-wrap tt-wrap">
            <table className="tt" data-testid="team-table">
              <thead><tr><th scope="col">Person</th><th scope="col">Work email</th><th scope="col">Reports to</th><th scope="col">Role</th><th scope="col">Daily list</th><th scope="col" className="r">Active</th></tr></thead>
              {TEAMS.map(([team, label]) => {
                const list = shown.filter((u) => u.team === team);
                if (!list.length) return null;
                const onList = list.filter((u) => u.bench && u.active && !u.leftAt).length;
                return (
                  <tbody key={team} className="tsec">
                    <tr className="tt-g" data-team={["design", "video"].includes(team) ? team : undefined}><th colSpan={6}><span className="lbl">{label}</span> <span className="num i2">{list.length}</span>{["design", "video"].includes(team) && <span className="i2"> {onList} on the daily list</span>}</th></tr>
                    {list.map((u) => {
                      const [txt, cls] = status(u);
                      return (
                        <tr key={u.id} className={`trow ${cls}`} data-testid={`team-row-${u.id}`}>
                          <th scope="row"><div className="tt-who"><span className="avatar" aria-hidden="true">{u.name.split(/\s+/).slice(0, 2).map((w) => w[0]).join("").toUpperCase()}</span>
                            <div><b>{u.name}</b><div className="hint0">{u.designation}</div></div></div></th>
                          <td>{u.email}<div className="hint0">{u.leftAt ? "Left CK" : u.mustChangePassword ? "Must choose a new password" : u.lastLoginAt ? "Signed in" : "Not signed in yet"}</div></td>
                          <td>{short[u.reportsTo] || ""}</td>
                          <td><span className="tag">{u.role}</span></td>
                          <td><DailySwitch me={me} u={u} run={run} /></td>
                          <td className="r"><span className="sr-only">{txt}</span><Actions me={me} u={u} run={run} setSheet={setSheet} /></td>
                        </tr>
                      );
                    })}
                  </tbody>
                );
              })}
            </table>
          </div>
        </div>
        <aside className="who-can" data-testid="who-can-panel">
          <div className="wc-h">Who can do what</div>
          <table className="wc">
            <thead><tr><th scope="col">Role</th><th scope="col">Runs own list</th><th scope="col">Moves cards</th><th scope="col">Adds clients and work</th><th scope="col">Sees client hours</th></tr></thead>
            <tbody>{WHO.map(([role, l, a, b, c, d]) => (
              <tr key={role} className={me.user.role === role ? "you" : ""}><th scope="row"><b>{l}</b><div className="num hint0">{current.filter((u) => u.role === role).length} IDs{me.user.role === role ? ", you" : ""}</div></th>
                {[a, b, c, d].map((v, i) => <td key={i}>{v === true ? <span className="wc-y" aria-label="Yes">✓</span> : v ? <b className="wc-own">{v}</b> : <span className="i2" aria-label="No">–</span>}</td>)}</tr>))}</tbody>
          </table>
          <p><b>Owner access (exports and the roster): {people.filter((u) => (u.grants || []).includes("export") && !u.leftAt).map((u) => u.short).join(", ")}.</b></p>
          <p>Makers and leads run their own list only when they are on the daily list.</p>
          <p>Leads move cards only within their own team. Planning tomorrow (estimates, the tray, carry over, publish) and fixing logged time stay with planners and management.</p>
          <p>Accounts add work to the request tray only. Planners and management put it on a list and plan tomorrow.</p>
          <p>Management can remove someone who has left CK. Their sign-in stops; hours they logged stay in reports.</p>
          <p>Everyone signs in with their work email and a password they choose the first time. Management resets a forgotten one.</p>
        </aside>
      </div>
      {sheet?.kind === "reset" && <ResetPasswordSheet person={sheet.u} onClose={() => { setSheet(null); load(); }} />}
      {sheet?.kind === "remove" && <RemoveSheet person={sheet.u} onClose={() => setSheet(null)}
        onConfirm={async () => { const id = sheet.u.id; setSheet(null); await run(post(`/people/${id}/remove`, { rev: sheet.u.rev }), id); }} />}
      {adding && <AddPerson onClose={() => setAdding(false)} onDone={() => { setAdding(false); load(); }} />}
    </div>
  );
}
